export default __webpack_public_path__ + "static/media/5a.b629829a.png";